import React from "react";
import { FcAndroidOs } from "react-icons/fc";
import { FaApple } from "react-icons/fa";
import type { VersionBreakdown } from "src/store/presenceSlice";

interface VersionAnalyticsCardProps {
  breakdown: VersionBreakdown;
}

const VersionAnalyticsCard: React.FC<VersionAnalyticsCardProps> = ({
  breakdown,
}) => {
  const isAndroid = breakdown.platform.toLowerCase() === "android";
  const isIOS = breakdown.platform.toLowerCase() === "ios";

  const platformIcon = isAndroid ? (
    <FcAndroidOs className="text-3xl" />
  ) : isIOS ? (
    <FaApple className="text-3xl text-indigo-400" />
  ) : (
    <div className="text-3xl">📱</div>
  );

  const platformColor = isAndroid
    ? "border-green-500/30 bg-green-500/5"
    : isIOS
      ? "border-indigo-500/30 bg-indigo-500/5"
      : "border-gray-500/30 bg-gray-500/5";

  return (
    <div
      className={`relative overflow-hidden rounded-xl border ${platformColor} backdrop-blur-xl p-5 transition-all hover:scale-[1.02] hover:shadow-xl`}
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-3">
          {platformIcon}
          <div>
            <div className="text-sm text-gray-400 uppercase tracking-wide">
              {breakdown.platform}
            </div>
            <div className="text-xl font-bold text-white">
              v{breakdown.version}
            </div>
          </div>
        </div>
        <div className="text-right">
          <div className="text-3xl font-extrabold text-white">
            {breakdown.count}
          </div>
          <div className="text-xs text-gray-400">
            {breakdown.count === 1 ? "user" : "users"}
          </div>
        </div>
      </div>

      {breakdown.buildNumbers.length > 0 && (
        <div className="mt-3 pt-3 border-t border-white/10">
          <div className="text-xs text-gray-400 mb-1">Build(s):</div>
          <div className="flex flex-wrap gap-1">
            {breakdown.buildNumbers.slice(0, 3).map((build, idx) => (
              <span
                key={idx}
                className="px-2 py-1 text-xs bg-white/10 rounded text-gray-300"
              >
                {build}
              </span>
            ))}
            {breakdown.buildNumbers.length > 3 && (
              <span className="px-2 py-1 text-xs text-gray-400">
                +{breakdown.buildNumbers.length - 3} more
              </span>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default VersionAnalyticsCard;
